module.exports = __webpack_public_path__ + "img/02.1631b820.png";